
  $(document).ready(function($) {
  "use strict";
        
    $('.menu-item-has-children > a').mouseenter(function(e) {
      var selected = $(this);
      if (selected.next('div.sub-menu-block').hasClass('is-hidden')) {
        selected.addClass('selected').next('div.sub-menu-block').removeClass('is-hidden');
      } else {
        selected.removeClass('selected').next('div.sub-menu-block').addClass('is-hidden');
      }
      e.preventDefault();
    }).mouseleave(function(e) {
      var selected = $(this);
      if (selected.next('div.sub-menu-block').hasClass('is-hidden')) {
        selected.addClass('selected').next('div.sub-menu-block').removeClass('is-hidden');
      } else {
        selected.removeClass('selected').next('div.sub-menu-block').addClass('is-hidden');
      }
      e.preventDefault();
    });

    
  // function megaMenu() {

  //   if($("#header").length) {
  //     var parentRow = $("#header");
  //     var parentLeft = parseInt(parentRow.css("marginLeft").replace('px', ''));
  //     }
  //   else {      
  //     var parentRow = $("#header");
  //     var parentLeft = parseInt(parentRow.offset().left);
     
  //   }
  //   var parentWidth = parentRow.width();        
  //   $("#header .page-width .dt-nav li:not(.close-nav)").each(function() {
  //     var thisItem = $(this);
  //     if(thisItem.hasClass('has-mega-menu')) {
  //       var thisItemLeft = thisItem.find('a').offset().left;
  //       var menuLeft = parseInt(thisItemLeft-parentLeft);    
  //       var menuLeft = menuLeft - 200;   // I commented this code because there is an issue with mega menu.
  //       thisItem.find('.sub-menu-block').css('width', parentWidth);
  //       thisItem.find('.sub-menu-block').css('left', -menuLeft);                  
  //     }
  //   });

  //   $("sticky-header .dt-nav li:not(.close-nav)").each(function() {
  //     var thisItem = $(this);
  //     if(thisItem.hasClass('has-mega-menu')) {
  //       var thisItemLeft = thisItem.find('a').offset().left;
  //       var menuLeft = parseInt(thisItemLeft-parentLeft);       
  //       thisItem.find('.sub-menu-block').css('width', parentWidth);
  //       thisItem.find('.sub-menu-block').css('left', -menuLeft);
  //     }      
  //   });

  //   window.setTimeout(function(){
  //     $(window).trigger('resize');
  //   }, 800);
  // }

 function megaMenu() {
  if ($("#header").length) {
    var parentRow = $("#header");
    var parentLeft = parseInt(parentRow.css("marginLeft").replace('px', ''));
  } else {      
    var parentRow = $("#header");
    var parentLeft = parseInt(parentRow.offset().left);
  }

  var parentWidth = parentRow.width();
  var viewportWidth = window.innerWidth;

  $("#header .page-width .dt-nav li:not(.close-nav)").each(function() {
    var thisItem = $(this);
    if (thisItem.hasClass('has-mega-menu')) {
      var thisItemLeft = thisItem.find('a').offset().left;
      var menuLeft = parseInt(thisItemLeft - parentLeft);
      console.log("menuLeft")
      console.log(menuLeft)
      // Adjust position based on viewport width
      var adjustment = viewportWidth >= 1440 ? 40 : 200;
      menuLeft -= adjustment;
      console.log("adjustment")
      console.log(adjustment)

      // Apply width and left properties with !important
      thisItem.find('.sub-menu-block').css({
        'width': parentWidth + 'px',
        'left': -menuLeft + 'px'
      }).attr("style", function(i, style) {
        return style + '; width: ' + parentWidth + 'px !important;';
      });
    }
  });

  $("sticky-header .dt-nav li:not(.close-nav)").each(function() {
    var thisItem = $(this);
    if (thisItem.hasClass('has-mega-menu')) {
      var thisItemLeft = thisItem.find('a').offset().left;
      var menuLeft = parseInt(thisItemLeft - parentLeft);

      var adjustment = viewportWidth >= 1440 ? 40 : 200;
      menuLeft -= adjustment;

      thisItem.find('.sub-menu-block').css({
        'width': parentWidth + 'px',
        'left': -menuLeft + 'px'
      }).attr("style", function(i, style) {
        return style + '; width: ' + parentWidth + 'px !important;';
      });
    }
  });

  window.setTimeout(function() {
    $(window).trigger('resize');
  }, 800);
}
    
  var megaMenuResize = false;
  $(window).bind("resize", function() {
    if(!megaMenuResize) {
      megaMenu();
      megaMenuResize = true;
    }
  });
  megaMenu();
});